import React from "react";

const OnlyTextQuestion = ({ text, onNext, canGoNext }) => {
  return (
    <>
      <div className="module-text-area" dangerouslySetInnerHTML={{ __html: text || "" }} />

      {canGoNext && (
        <button className="btn nextAnswer" onClick={onNext} style={{ display: "inline-block" }}>
          Наступне завдання
        </button>
      )}
    </>
  );
};

export default OnlyTextQuestion;
